{
  "About Page": "About Page",
  "Add Company Logo": "Add Company Logo",
  "Add Google, Facebook, or Custom Link": "Add Google, Facebook, or Custom Link",
  "Add Link": "Add Link",
  "Add Logo": "Add Logo",
  "Add Social Platform": "Add Social Platform",
  "Add the same company logo to all of your selected location(s).": "Add the same company logo to all of your selected location(s).",
  "Add various links": "Add various links",
  "Address Line 1": "Address Line 1",
  "Address Line 2": "Address Line 2",
  "Are You Sure?": "Are You Sure?",
  "Are you sure you want to delete it?": "Are you sure you want to delete it?",
  "Are you sure you want to update it?": "Are you sure you want to update it?",
  "Back": "Back",
  "Beta": "Beta",
  "Blog": "Blog",
  "Brand Details": "Brand Details",
  "Brand Details Manage All": "Brand Details Manage All",
  "Canada": "Canada",
  "Cancel": "Cancel",
  "Changes will override current settings.": "Changes will override current settings.",
  "City": "City",
  "Common logo preview": "Common logo preview",
  "Company Logo": "Company Logo",
  "Confirm Deletion": "Confirm Deletion",
  "Confirm Update": "Confirm Update",
  "Connect Social Platforms": "Connect Social Platforms",
  "Contact Page": "Contact Page",
  "Country": "Country",
  "Custom": "Custom",
  "Custom Link": "Custom Link",
  "Delete": "Delete",
  "Delete Link": "Delete Link",
  "Delete Logo": "Delete Logo",
  "Delete Platform": "Delete Platform",
  "Deleting logo will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting logo will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Deleting logo...": "Deleting logo...",
  "Deleting this link will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting this link will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Deleting this social platform will remove it from your brand details, making it unavailable for easy integration into your Weave features.": "Deleting this social platform will remove it from your brand details, making it unavailable for easy integration into your Weave features.",
  "Edit in Email Settings": "Edit in Email Settings",
  "Email Address": "Email Address",
  "Enter Platform Name ...": "Enter Platform Name ...",
  "Enter URL ...": "Enter URL ...",
  "External Name": "External Name",
  "FAQ": "FAQ",
  "Facebook": "Facebook",
  "Failed to delete logo. Please try again.": "Failed to delete logo. Please try again.",
  "Google": "Google",
  "Help Center": "Help Center",
  "Implement your brand and create a customized experience across Weave.": "Implement your brand and create a customized experience across Weave.",
  "Internal Name": "Internal Name",
  "Links": "Links",
  "Loading branding details...": "Loading branding details...",
  "Location Address": "Location Address",
  "Location Contact Information": "Location Contact Information",
  "Location Name": "Location Name",
  "Locations": "Locations",
  "Logo": "Logo",
  "Logo Preview": "Logo Preview",
  "Logo deleted successfully!": "Logo deleted successfully!",
  "Logo upload failed. Please try again.": "Logo upload failed. Please try again.",
  "Logo uploaded successfully!": "Logo uploaded successfully!",
  "Manage All": "Manage All",
  "Manage your branding settings": "Manage your branding settings",
  "Map": "Map",
  "No phone numbers available": "No phone numbers available",
  "Other": "Other",
  "Phone Number": "Phone Number",
  "Platform Name": "Platform Name",
  "Please enter a URL.": "Please enter a URL.",
  "Please enter a complete website address (e.g., https://example.com).": "Please enter a complete website address (e.g., https://example.com).",
  "Please enter a valid URL.": "Please enter a valid URL.",
  "Please enter a valid website address: for example, demo.com or www.demo.com or http://demo.com or http://www.demo.com": "Please enter a valid website address: for example, demo.com or www.demo.com or http://demo.com or http://www.demo.com",
  "Postal Code": "Postal Code",
  "Promotional Page": "Promotional Page",
  "Referral Page": "Referral Page",
  "Save": "Save",
  "Select New Image": "Select New Image",
  "Select location": "Select location",
  "Select type": "Select type",
  "Selected logo preview": "Selected logo preview",
  "Shop": "Shop",
  "State": "State",
  "The selected image has no URL. Please select a different image.": "The selected image has no URL. Please select a different image.",
  "There was an issue with the file you uploaded. Please try again with a different file.": "There was an issue with the file you uploaded. Please try again with a different file.",
  "This action will result in the removal of your logo from future Forms.": "This action will result in the removal of your logo from future Forms.",
  "This action will update your current brand logo across all your locations.": "This action will update your current brand logo across all your locations.",
  "This is the name used within Weave to identify this location. To change it, please contact Weave Support.": "This is the name used within Weave to identify this location. To change it, please contact Weave Support.",
  "This is the public-facing address that will represent this location.": "This is the public-facing address that will represent this location.",
  "This is the public-facing business name your customers will see in message templates and emails.": "This is the public-facing business name your customers will see in message templates and emails.",
  "This is the public-facing contact information that will represent this location in cases where phone numbers and emails are pre-filled.": "This is the public-facing contact information that will represent this location in cases where phone numbers and emails are pre-filled.",
  "Type": "Type",
  "URL": "URL",
  "URL must start with http:// or https://": "URL must start with http:// or https://",
  "USA": "USA",
  "Unable to delete logo. Please try in sometime": "Unable to delete logo. Please try in sometime",
  "Unable to upload logo. Please try in sometime": "Unable to upload logo. Please try in sometime",
  "Unspecified": "Unspecified",
  "Update": "Update",
  "Upload New": "Upload New",
  "Uploading logo...": "Uploading logo...",
  "Web Page": "Web Page",
  "You cannot manage all for Facebook or Google settings due to authorization restrictions.": "You cannot manage all for Facebook or Google settings due to authorization restrictions.",
  "You cannot manage all for this particular setting.": "You cannot manage all for this particular setting.",
  "Your Brands": "Your Brands",
  "{{count}} Locations_one": "{{count}} Locations",
  "{{count}} Locations_other": "{{count}} Locations"
}
